import Footer from "../Footer";
import { accounttypes } from "../Array";
import { useParams } from "react-router-dom";

function Accounttype() {
  const { id } = useParams();
    const account = accounttypes.find(
    (item) => item.id === Number(id)
  );
  return (
    <>
       <div className="container sub-page mt-4">
        <div className="mt-5">
          <h2 className="text-center">{account.title}</h2>

          <div className="d-flex justify-content-center sub-img">
            <img style={{height:"300px"}} src={account.image} alt={account.title} />
          </div>

          <div className="mt-5">
            {account.sections.map((section, index) => (
              <div key={index} className="d-flex flex-column gap-2">
                <h4>{section.heading}</h4>

                {Array.isArray(section.content) ? (
                  section.content.map((text, i) => (
                    <p key={i}>{text}</p>
                  ))
                ) : (
                  <p>{section.content}</p>
                )}

                {index === 0 && section.pointheading && (
                  <h6 className="mt-2">{section.pointheading}</h6>
                )}

                {section.points && (
                  <ul className="pl-3 d-flex flex-column gap-3">
                    {section.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}

                <p className="">{section.h2}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Accounttype;
